<template>
    <div v-if="show">

        <!--liste des boutons -->
        <v-btn class="primary" :class="datas.button.class" v-for="(mail,i) in listMails" :key="i" @click="SelectMail(mail)"><v-icon>mdi-email-outline</v-icon> {{ mail.titre }}</v-btn>
        <!-- Liste des attente d'envoi d'email-->
        <div v-for="(pending,p) in mailPending" :key="pending.key || p">
            <div v-if="pending.group.includes(paramsEmail.id)">
                {{ listMails[pending.selectedMail.id] ? listMails[pending.selectedMail.id].titre : pending.selectedMail.objet }}
                <span v-if="pending.planified && moment(pending.planified).isAfter(moment())"> : {{ pending.total }} mails planifiés le {{ moment(pending.planified).format('DD/MM/YYYY à HH:mm') }}</span>
                <span v-else> en cours d'envoi (restant : {{ pending.group.length }}/{{ pending.total }})</span>
                <v-btn x-small @click="annulSend(pending)">Annuler l'envoi</v-btn> - 
                <v-btn x-small @click="annulSend(pending,true)">Annuler l'envoi groupé</v-btn>
            </div>
        </div>

        <v-dialog
        :retain-focus="false"
        width="50%" 
        v-model="dialog"
        :fullscreen="$vuetify.breakpoint.xs">
        <OverLay/>
            <v-card class="app-theme-bg-page">
                <v-card-title class="app-theme-bg-modal-header py-3 px-4">
                    <span class="text-h6 font-weight-medium">Email d'envoi : </span>
                    <span class="text-subtitle-1 font-weight-medium"> {{ paramsEmail.mailfrom.name }} - {{ paramsEmail.mailfrom.from }} </span>
                <v-spacer></v-spacer>
                <v-btn icon aria-label="Fermer la fenêtre d’envoi" @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text class="app-theme-bg-page">
                <!--liste des pièces jointes -->

                <div class="mb-4">
                    <div class="text-subtitle-2 mb-1">Pièces jointes</div>
                    <div class="text-caption text--secondary mb-2">Choisissez les documents à joindre à cet email.</div>
                    <div class="email-attachments-grid">
                    <template v-if="paramsEmail.attachements.length && paramsEmail.selectedMail.id">
                        <div v-for="(attach,i) in paramsEmail.attachements" :key="'p'+i" class="email-attachment"
                            :class="{'email-attachment--selected':paramsEmail.includeAttachement[paramsEmail.selectedMail.id][attach.mod]}">
                            <v-checkbox class="ma-0 pa-0" hide-details color="primary"
                                :input-value="paramsEmail.includeAttachement[paramsEmail.selectedMail.id][attach.mod]"
                                :aria-label="'Joindre ' + attach.name"
                                @change="value => includePJFile(attach,value)" />
                            <v-icon small :color="paramsEmail.includeAttachement[paramsEmail.selectedMail.id][attach.mod] ? 'primary' : undefined">mdi-file-document-outline</v-icon>
                            <div class="email-attachment__content">
                                <span class="email-attachment__name" :title="attach.name">{{ attach.name }}</span>
                                <span class="email-attachment__status" :class="paramsEmail.includeAttachement[paramsEmail.selectedMail.id][attach.mod] ? 'primary--text' : 'text--secondary'">
                                    {{ paramsEmail.includeAttachement[paramsEmail.selectedMail.id][attach.mod] ? 'Incluse' : 'Non incluse' }}
                                </span>
                            </div>
                        </div>
                    </template>
                    <div v-for="(file,i) in $store.getters['getGedFile']" :key="'g'+i" class="email-attachment email-attachment--selected">
                        <v-icon small color="primary">mdi-file-document-outline</v-icon>
                        <div class="email-attachment__content">
                            <span class="email-attachment__name" :title="file.path.split('/').pop()">{{ file.path.split("/").pop() }}</span>
                            <span class="email-attachment__status text--secondary">Incluse · GED</span>
                        </div>
                        <v-btn icon small @click="$store.dispatch('removeGedFile',file)"
                            :aria-label="'Retirer ' + file.path.split('/').pop()" title="Retirer cette pièce jointe">
                            <v-icon small>mdi-delete-outline</v-icon>
                        </v-btn>
                    </div>
                    </div>

                            <div v-if="isGed.id">
                                <v-btn @click="gotoGed" outlined small color="primary" class="mt-2">
                                    <v-icon left small>mdi-folder-open-outline</v-icon>Ajouter depuis la GED
                                </v-btn>
                                <v-dialog
                                :retain-focus="false"
                                width="50%" 
                                v-model="dialogged"
                                @click:outside="$store.dispatch('removeAllGedFile')"
                                :fullscreen="$vuetify.breakpoint.xs">
                                <v-card class="app-theme-bg-page">
                                    <v-card-title class="app-theme-bg-modal-header py-2 px-3">
                                        <span class="text-subtitle-1 font-weight-medium">Documents</span>
                                    <v-spacer></v-spacer>
                                    <v-btn icon aria-label="Fermer la fenêtre des documents" @click="closeGed"><v-icon>mdi-close</v-icon></v-btn>
                                    </v-card-title>
                                    <v-divider />
                                <component v-bind:is="$modules.ged.components.client" v-if="dialogged" :idmodule="isGed.id" :page="page" :modal="modal" :modalKey="modalKey" :parent="parent" :customparams="isGed.params"/>
                                <v-card-actions class="app-theme-bg-toolbar">
                                    <v-spacer></v-spacer>
                                    <v-btn @click="dialogged=false">intégrer</v-btn>
                                </v-card-actions>
                                </v-card>
                                </v-dialog>
                            </div>
                </div>




                <TextField
                :item="{ name: 'Adresse retour', value: 'replyemail', defaultprops:{ show: true, persistenthint: true,
                    description: 'Adresse de réponse pour les destinataires. Par défaut : ' + (paramsEmail.mailfrom.from || 'l’adresse d’envoi') + '.' }}"
                :valField="paramsEmail.selectedMail.replyemail"
                :keyup="(item,model)=> { changeMail(item,model,'replyemail') }"
                />

                <TextField
                :item="{ name: 'Objet', value: 'objet' ,defaultprops:{ show: true }}"
                :valField="paramsEmail.selectedMail.objet"
                :keyup="(item,model)=> { changeMail(item,model,'objet') }"
                />

                <div class="email-send-tabs">
                <v-tabs v-model="tab" grow class="email-send-tabs__headers">

                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#indiv">Individuel</v-tab>
                <v-tab v-if="datas.groupEnabled" href="#group" @click="loadEmailGroup">envoi groupé</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab" class="pa-2 email-send-tabs__content">

                <v-tab-item id="indiv" value="indiv" >
                <!-- début de l'envoi individuel-->
                <v-row>
                    <v-col>
                        
                        <ArrayTable 
                            :item="{otherparams:{
                                arrayTable:[
                                    {type:'',key:'Name',name:'alias'},                           
                                    {type:'',key:'Email',name:'adresse e-mail'}]}
                            ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajouter une adresse'}}"
                            :valField="paramsEmail.emails"
                            :change="(item,model)=> { changeParams(item,model,'emails') }"
                            />
                        <p v-if="!hasIndividualRecipients">Ajoutez au moins une adresse pour envoyer l'email.</p>

                            
                        <div v-if="fieldForUpdate">
                            <fromBDD 
                            :item="{fromBDD:fieldForUpdate,defaultprops:{show:true}}"
                            :page="page"
                            :valField="paramsEmail.selectedMail.corp"
                            :keyup="(item,model)=> { changeMail(item,model,'corp') }"
                            /> 
                        </div>
                        <div v-else>
                            <texteditor
                            :page="page"
                            :item="{name: 'corp du mail',value: 'corp',
                            
                            defaultprops:{ show: true},
                            otherparams : {menueditor:[]}
                            }"
                            :keyup="(item,model)=> { changeMail(item,model,'corp') }"
                            :valField="paramsEmail.selectedMail.corp"
                            />
                        </div>

                    </v-col>

                    </v-row>
                    <v-row>
                        <v-col class="col-12 text-center">

                            <v-btn @click="send" class="primary" :disabled="!hasIndividualRecipients">envoyer</v-btn>

                        </v-col>
                    </v-row>
                    <!-- fin de l'envoi individuel-->
                    </v-tab-item>





                    <!-- début de l'envoi groupé-->




                    <v-tab-item v-if="datas.groupEnabled" id="group" value="group">
                        <v-row>
                            <v-col>
                                <p>L'envoi groupé est personnalisé par les pièces jointes que vous avez choisi, et l'objet du mail.</p>
                                <p>Le texte ainsi que les expéditeurs seront selectionnés selon le paramétrage par défaut.</p>
                                <p align="center"><b>{{ selectedGroup.length }} sélections / {{ filteredGroupRows.length }} lignes</b></p>

                                <p>
                                    <SwitchC
                                    :item=" { name: 'Autoriser l\'envoi aux personnes qui sont en statut \'envoyé\' ou \'en cours\'.',value: '',liste: [{ text: 'OUI', value: true },{ text: 'NON', value: false }],
                                        defaultprops:{ show: true, column: false }}"
                                    :change="(item,model) => { removeOrAllowAll = model;  }"
                                    :valField="removeOrAllowAll"
                                    />            
                                </p>
                                
                                <v-alert v-if="groupError" type="error" text dense>
                                    {{ groupError }}
                                    <v-btn text small @click="loadEmailGroup">Réessayer</v-btn>
                                </v-alert>
                                <div v-if="groupLoaded && groupFilterFields.length" class="mb-2">
                                    <div class="d-flex align-center mb-1">
                                        <span class="text-subtitle-2">Filtrer cette liste</span>
                                        <v-spacer />
                                        <v-btn small text @click="resetGroupFilters">Réinitialiser les filtres</v-btn>
                                    </div>
                                    <v-row dense>
                                        <v-col v-for="field in groupFilterFields" :key="field.alias" cols="12" sm="4">
                                            <component :is="getFieldComponent(field.format)" :item="field" type="search"
                                                :page="page" :modalKey="modalKey" :valField="groupFilterValues[field.alias] == null ? '' : groupFilterValues[field.alias]"
                                                :keyup="(item,value) => changeGroupFilter(item,value)"
                                                :change="(item,value,key) => changeGroupFilter(item,value,key)" />
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-text-field v-if="groupLoaded" v-model="groupSearch" label="Rechercher dans le tableau"
                                    append-icon="mdi-magnify" single-line hide-details class="mb-3" />
                                <v-data-table
                                    :headers="groupHeaders" :items="filteredGroupRows" item-key="id"
                                    :loading="groupLoading" :page.sync="groupPage"
                                    :items-per-page="10" :footer-props="{'items-per-page-options':[10], 'show-first-last-page':true}"
                                    :custom-sort="sortGroupRows" :mobile-breakpoint="0" show-select
                                    no-data-text="Aucune personne dans cette liste" no-results-text="Aucun résultat"
                                    loading-text="Chargement de la liste…">
                                    <template v-slot:[`header.data-table-select`]>
                                        <v-simple-checkbox :value="allGroupSelected" :indeterminate="someGroupSelected"
                                            :disabled="!selectableFilteredGroupRows.length" aria-label="Sélectionner tous les résultats de la recherche, toutes les pages"
                                            @input="toggleAllGroup" />
                                    </template>
                                    <template v-slot:[`item.data-table-select`]="{ item }">
                                        <v-simple-checkbox :value="selectedGroup.includes(item.id)" :disabled="!item.isSelectable"
                                            :aria-label="'Sélectionner la ligne ' + item.id" @input="value => toggleGroupRow(item, value)" />
                                    </template>
                                    <template v-for="header in groupHeaders" v-slot:[`item.${header.value}`]="{ item }">
                                        <VisualRenderer v-if="header.visuel" :key="header.value" :item="header.visuel" :line="item" :page="modalKey" />
                                        <span v-else :key="header.value">{{ item[header.value] }}</span>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="col-12 text-center">
                                <Radio 
                                    :change="(item,value) => { isplann = value }"
                                    :valField="isplann"
                                    :item="{name:'Envoi ',value:'isplann',liste:[{text:'Maintenant',value:'now'},{text:'Planifier',value:'after'}],
                                    defaultprops:{show:true, column:false, class:'pa-0 ma-0' }}"
                                    />  

                                <dateTimePicker
                                v-if="isplann == 'after' "
                                    :item="{ name: 'Planifier le', value: 'planified' ,defaultprops:{ show: true}}"
                                    :valField="paramsEmail.planified"
                                    :change="(item,model)=> { paramsEmail.planified = model }"
                                    /> 

                                <v-btn @click="sendgroup" class="primary" :disabled="!groupLoaded || groupLoading || !selectedGroup.length">envoyer</v-btn>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    </v-tabs-items>
                </div>

                    </v-card-text>
                </v-card>

            </v-dialog>
        </div>
</template>
        
        
        
<script>
import fromBDD from '../../fields/fromBDD.vue';
import { client } from '../mixins'; 
export default {

    name: "sendEmail",

    mixins : [client],

    components: {
        texteditor : () => import("@/components/fields/texteditor.vue"),
        TextField: () => import("@/components/fields/textfield.vue"),
        SwitchC: () => import("@/components/fields/switch.vue"),
        dateTimePicker: () => import("@/components/fields/dateTimePicker.vue"),
        ArrayTable: () => import("@/components/fields/arrayTable.vue"),
        OverLay: () => import('@/components/outils/overlay.vue'),
        VisualRenderer: () => import('../../engine/outils/constructVisuel/display/Renderer.vue'),
        Radio    : () => import('@/components/fields/radio.vue'),
        fromBDD
    },

    data: function () {

        return {
            tab : '',
            AllowedDisplay: true,
            show: false,
            datas: {},
            isplann : 'now',
            paramsEmail: { selectedMail : {},emails : [], send:false, attachements : [], mailfrom : {},includeAttachement : {}, planified : new Date() },
            querys: {},
            dialog: false,
            dialogged : false,
            fieldForUpdate : false,
            listMails : [],
            listGroup : {liste:[],headers:[],'mailwaiting':[],'mailsent':[]},
            groupLoaded: false,
            groupLoading: false,
            groupError: '',
            groupRequestId: 0,
            groupPage: 1,
            groupSearch: '',
            groupFilterValues: {},
            selectedGroup:[],
            //liste des groupes en attente d'envoi
            mailPending : [],
            //liste des id en attente d'envoi en fonction du mail selectionné
            selWaiting : [],
            //liste des id deja envoyés en fonction du mail selectionné
            selSent : [],
            //permet de switch si possibilité d'envoi à tte les pers. meme encours ou attente, ou non
            removeOrAllowAll : false,
            reload : 0,
            isGed: {},
            typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform,
        }
    },

    computed : {
            groupContextKey() {
                const preparationKeys = ['selectedMail', 'emails', 'send', 'attachements', 'mailfrom', 'includeAttachement', 'planified'];
                const context = Object.fromEntries(Object.entries(this.paramsEmail).filter(([key]) => !preparationKeys.includes(key)));
                return JSON.stringify([this.idmodule, context, this.querys]);
            },
            groupHeaders() {
                const columns = this.listGroup.colonnes || [];
                if (!columns.length) return this.listGroup.headers;
                return columns.map((column, index) => ({
                    text: column.title || column.key, value: '__group_visual_' + index,
                    align: column.align || 'start', width: column.width || undefined,
                    sortable: column.sortable === true, sortby: column.sortby || column.key, visuel: column,
                })).concat([{text:'État', value:'etat'}]);
            },
            selectableGroupRows() {
                return this.listGroup.liste.filter(row => row.isSelectable);
            },
            groupFilterFields() {
                return (this.listGroup.searchFields || []).map(source => {
                    const field = JSON.parse(JSON.stringify(source));
                    field.filterFormat = field.format;
                    field.otherparams = {...field.otherparams, store:[]};
                    field.directives = [];
                    field.options = {...field.options, add:{...(field.options && field.options.add), set:false}};
                    field.defaultprops = {...field.defaultprops, required:false, clearable:true};
                    // Un booléen vide signifie « Tous », et non « Non ».
                    if (field.format === 'switch') {
                        field.format = 'select';
                        field.dynamicsearch = false;
                        field.liste = [{text:'Tous', value:''}, {text:'Oui', value:true}, {text:'Non', value:false}];
                        field.defaultprops.multiple = false;
                    } else if (field.format === 'radio') {
                        // Le radio moteur est obligatoire : une liste permet ici de conserver « Tous ».
                        field.format = 'select';
                    }
                    return field;
                });
            },
            filteredGroupRows() {
                const search = typeof this.groupSearch === 'string' ? this.groupSearch.trim() : '';
                // Même prédicat que Vuetify, sur les alias réels plutôt que les clés de colonnes visuelles.
                const fields = this.listGroup.headers.filter(header => header.filterable !== false
                    && !['id', 'sent', 'isSelectable'].includes(header.value)).map(header => header.value);
                return this.listGroup.liste.filter(row => (!search || fields.some(field => {
                    const value = row[field];
                    return value != null && typeof value !== 'boolean'
                        && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
                })) && this.groupFilterFields.every(field => this.matchesGroupFilter(row[field.alias], this.groupFilterValues[field.alias], field)));
            },
            selectableFilteredGroupRows() {
                return this.filteredGroupRows.filter(row => row.isSelectable);
            },
            allGroupSelected() {
                const selected = new Set(this.selectedGroup);
                return this.selectableFilteredGroupRows.length > 0 && this.selectableFilteredGroupRows.every(row => selected.has(row.id));
            },
            someGroupSelected() {
                const selected = new Set(this.selectedGroup);
                return this.selectableFilteredGroupRows.some(row => selected.has(row.id)) && !this.allGroupSelected;
            },
            hasIndividualRecipients() {
                return Array.isArray(this.paramsEmail.emails) && this.paramsEmail.emails.length > 0;
            },
            modEditForm() {
                return this.$store.getters['listForm'](this.modalKey);
            }
    },

    watch: {

        tab(value) {
            if (value === 'group' && this.dialog) this.loadEmailGroup();
        },
        groupSearch() { this.groupPage = 1; },
        groupFilterValues: {deep:true, handler() { this.groupPage = 1; }},
        groupContextKey() {
            this.resetEmailGroup();
            if (this.dialog && this.tab === 'group') this.$nextTick(this.loadEmailGroup);
        },

        'modEditForm.typeform': {
                // permet de rafraichir quand la modal de modif du module de la page se ferme
                handler(newVal,oldVal) {
                    if(oldVal!='new') return;
                        this.typePage = newVal
                        this.initiateParams()
                        this.callAPI()
                },deep:true,
            },
            
            dialog(val) {
                if(val) this.reload++;
                else this.resetEmailGroup();
            },

            removeOrAllowAll() {
                this.applyGroupSelection();
            }
    },

    methods: {

        changeGroupFilter(field, value, selectedKey = 'value') {
            const selectedValue = option => option !== null && typeof option === 'object'
                ? option[selectedKey] : option;
            const normalized = Array.isArray(value) ? value.map(selectedValue).filter(option => option !== undefined) : selectedValue(value);
            this.$set(this.groupFilterValues, field.alias, normalized);
        },

        resetGroupFilters() {
            this.groupFilterValues = {};
        },

        groupRowValues(value) {
            if (Array.isArray(value)) return value;
            if (typeof value === 'string' && value.trim().startsWith('[')) {
                try {
                    const parsed = JSON.parse(value);
                    if (Array.isArray(parsed)) return parsed;
                } catch (error) { /* Une valeur texte peut commencer par un crochet. */ }
            }
            return [value];
        },

        matchesGroupFilter(value, filter, field) {
            if (filter === null || filter === undefined || filter === '' || Array.isArray(filter) && !filter.length) return true;
            const values = this.groupRowValues(value).filter(item => item !== null && item !== undefined);
            const format = field.filterFormat || field.format;
            if (['select', 'autocomplete', 'radio'].includes(format)) {
                const selected = (Array.isArray(filter) ? filter : [filter]).map(String);
                return values.some(item => selected.includes(String(item)));
            }
            if (format === 'switch') {
                const booleanValue = item => [true, 1, '1', 'true'].includes(item) ? true
                    : [false, 0, '0', 'false'].includes(item) ? false : null;
                return values.some(item => booleanValue(item) !== null && booleanValue(item) === booleanValue(filter));
            }
            if (['number', 'conversion', 'slider'].includes(format)) {
                return values.some(item => item !== '' && Number.isFinite(Number(item)) && Number(item) === Number(filter));
            }
            if (['datepicker', 'datetimepicker', 'datetimeselect', 'timeonlypicker'].includes(format)) {
                const output = format === 'datepicker' ? 'YYYY-MM-DD' : format === 'timeonlypicker' ? 'HH:mm' : 'YYYY-MM-DD HH:mm';
                const dateValue = item => {
                    const date = this.moment(item, [this.moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY', 'DD/MM/YYYY HH:mm', 'HH:mm'], true);
                    return date.isValid() ? date.format(output) : null;
                };
                const expected = dateValue(filter);
                return expected !== null && values.some(item => dateValue(item) === expected);
            }
            const search = String(filter).trim().toLocaleLowerCase();
            return !search || values.some(item => String(item).toLocaleLowerCase().includes(search));
        },

        resetEmailGroup() {
            // Invalide également une réponse arrivée après un changement de contexte.
            this.groupRequestId++;
            this.groupLoaded = false;
            this.groupLoading = false;
            this.groupError = '';
            this.groupPage = 1;
            this.groupSearch = '';
            this.groupFilterValues = {};
            this.selectedGroup = [];
            this.listGroup = {liste:[], headers:[], mailwaiting:{}, mailsent:{}, colonnes:[]};
        },

        async loadEmailGroup() {
            if (!this.dialog || this.tab !== 'group' || !this.datas.groupEnabled || this.groupLoaded || this.groupLoading) return;
            const requestId = ++this.groupRequestId;
            this.groupLoading = true;
            this.groupError = '';
            try {
                const response = await this.API({type:'post', url:'displaymodule', params:{
                    id:this.idmodule, operation:'loadEmailGroup',
                    params:{...this.paramsEmail, send:false}, querys:this.querys,
                }});
                if (requestId !== this.groupRequestId || !this.dialog) return;
                if (!response.data.success) throw new Error(response.data.message || 'Impossible de charger la liste.');
                this.listGroup = {...response.data.group, liste:response.data.group.liste.map(row => ({...row}))};
                this.applyGroupSelection();
                this.groupLoaded = true;
            } catch (error) {
                if (requestId === this.groupRequestId) this.groupError = error.message || 'Impossible de charger la liste.';
            } finally {
                if (requestId === this.groupRequestId) this.groupLoading = false;
            }
        },

        applyGroupSelection() {
            const mailId = this.paramsEmail.selectedMail.id;
            this.selWaiting = this.listGroup.mailwaiting[mailId] || [];
            this.selSent = this.listGroup.mailsent[mailId] || [];
            this.listGroup.liste = this.listGroup.liste.map(row => {
                const waiting = this.selWaiting.includes(row.id);
                const sent = this.selSent.includes(row.id);
                return {...row, etat:[waiting ? 'en cours' : '', sent ? 'envoyé' : ''].filter(Boolean).join(', '),
                    isSelectable:this.removeOrAllowAll || (!waiting && !sent)};
            });
            const eligible = new Set(this.selectableGroupRows.map(row => row.id));
            this.selectedGroup = this.selectedGroup.filter(id => eligible.has(id));
        },

        toggleAllGroup(value) {
            // Toutes les pages des résultats, sans modifier la sélection hors recherche.
            const matching = new Set(this.selectableFilteredGroupRows.map(row => row.id));
            this.selectedGroup = value ? [...new Set([...this.selectedGroup, ...matching])]
                : this.selectedGroup.filter(id => !matching.has(id));
        },

        toggleGroupRow(row, value) {
            if (!row.isSelectable) return;
            this.selectedGroup = value ? [...new Set([...this.selectedGroup, row.id])] : this.selectedGroup.filter(id => id !== row.id);
        },

        sortGroupRows(items, fields = [], descending = []) {
            const collator = new Intl.Collator('fr', {numeric:true, sensitivity:'base'});
            return [...items].sort((a, b) => {
                for (let index = 0; index < fields.length; index++) {
                    const header = this.groupHeaders.find(column => column.value === fields[index]);
                    const key = header && header.sortby || fields[index];
                    const comparison = collator.compare(a[key] == null ? '' : a[key], b[key] == null ? '' : b[key]);
                    if (comparison) return descending[index] ? -comparison : comparison;
                }
                return 0;
            });
        },

        callAPI: function () {
            if(this.typePage=='new') return
            this.API({ type: 'post', url: 'displaymodule', params: { id: this.idmodule, params: this.paramsEmail, querys: this.querys } }).then((resp) => {
                this.manageDatas(resp.data)
            })

        },

        manageDatas(data) {
            this.datas = data;
                if (!data.success) {
                    this.AllowedDisplay = false;
                    this.$toast.error(data.message)
                    return false;
                }
                this.listMails = data.listmails;
                this.resetEmailGroup();
                
                    this.paramsEmail.emails = Array.isArray(data.emails) ? data.emails.map(email => ({...email})) : []
                    this.paramsEmail.mailfrom = data.mailfrom
                    this.paramsEmail.attachements = data.attachements
                    this.paramsEmail.includeAttachement = data.includeAttachement
                    this.isGed = data.ged;
                    this.mailPending = data.mailpending;
                    if(data.idField) this.fieldForUpdate = data.idField                


                this.show = true
                if(this.querys.selected && this.listMails[this.querys.selected]) {

                    this.SelectMail(this.listMails[this.querys.selected]);
                }
                if (this.dialog && this.tab === 'group') this.$nextTick(this.loadEmailGroup);
        },

        changeParams(item, value, type) {
            this.paramsEmail[type] = value
        },

        changeMail(item, value, type) {
            this.paramsEmail.selectedMail[type] = value
        },

        send() {
            if (!this.hasIndividualRecipients) {
                this.$toast.info("Ajoutez au moins une adresse pour envoyer l'email.");
                return false;
            }
            //si c'est un envoi de groupe on va d'abord envoyer les intructions pour préparer l'envoi

            this.$store.dispatch('textOverlay','Envoi du mail en cours');
            this.$store.dispatch('getoverlay', true)
            this.paramsEmail.send = true
            this.API({ type: 'post', url: 'displaymodule', params: { id: this.idmodule, params: this.paramsEmail, querys: this.querys, gedfiles:this.$store.getters['getGedFile'] } }).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                    return false;
                }
                this.$toast.success("l'email est bien envoyé !")
                this.dialog = false;
                this.$store.dispatch('removeAllGedFile');
                })            
        },


        sendgroup() {
            if(this.selectedGroup.length==0) {
                this.$toast.info('Veuillez selectionner au moins une ligne') 
                return false;
            }
            if(this.isplann=='after' && this.moment() > this.moment(this.paramsEmail.planified)) {
                this.$toast.info("La date d'envoi doit etre supérieure à la date courante"); 
                return false;
            }

            


            if(confirm('Vous allez programmer '+this.selectedGroup.length+' mails, confirmer cette action ?')) {
            this.$store.dispatch('textOverlay',"Préparation de l'envoi groupé");
            this.$store.dispatch('getoverlay', true)            

            this.API({ type: 'post', url: 'displaymodule', params: { group : this.selectedGroup, id: this.idmodule, planified: this.isplann == 'after' ? this.paramsEmail.planified : null, params: this.paramsEmail, querys: this.querys, gedfiles:this.$store.getters['getGedFile'] }}).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                    return false;
                } else {
                    this.$toast.success(resp.data.message)
                }
                this.dialog = false;
                this.$store.dispatch('removeAllGedFile');
                this.selectedGroup = []
                this.callAPI();
                
                }) 
            }

        },

        annulSend(email,group) {
            this.$store.dispatch('textOverlay',"Suppression de l 'envoi");
            this.$store.dispatch('getoverlay', true) 
            this.API({ type: 'post', url: 'displaymodule', params: { annulsend : email.key, idannul : this.paramsEmail.id ,allcampaign : group, id: this.idmodule, params: this.paramsEmail}}).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                } else {
                    this.$toast.success(resp.data.message)
                }
                this.callAPI();
                this.$store.dispatch('getoverlay', false)
                })
        },


        initiateParams() {

        const params = this.resolveModuleParams()
        this.paramsEmail = {...this.paramsEmail, ...params}
        
        this.querys = this.$store.getters.specificPage(this.modalKey).querys
        
        if (this.hook == 'search') this.querys.global = this.$store.getters.getStringSearch;
        },

        gotoGed() {
            this.isGed.params.select = true;
            this.dialogged = true;
        },

        closeGed() {
            this.$store.dispatch('removeAllGedFile'); 
            this.dialogged=false;
        },

        SelectMail(mail) {

            this.resetEmailGroup();
            this.tab = 'indiv';
            this.paramsEmail.selectedMail = {
                ...mail,
                replyemail: mail.replyemail ?? '',
                replyname: mail.replyname ?? '',
            }
            this.dialog = true
        },

        closeDialog() {
            this.$store.dispatch('removeAllGedFile');
            this.dialog = false
            this.paramsEmail.selectedMail = {}
            this.selWaiting = []
            this.selSent = []
            this.selectedGroup = []
            this.removeOrAllowAll = false
            this.listGroup.liste.forEach((v,i) => {
                this.listGroup.liste[i]['etat'] = '';
                this.listGroup.liste[i]['isSelectable'] = true;
            })
        },

        includePJFile(attach,isinclude) {
            this.paramsEmail.includeAttachement[this.paramsEmail.selectedMail.id][attach.mod] = isinclude;
        }


    },
    mounted() {
        this.initiateParams()

        if(this.typePage=='new') return

        let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 

    },

    created() {

    }

}

</script>

<style scoped>
.email-send-tabs {
    overflow: hidden;
    border: 1px solid #e5e7ef;
    border-radius: 10px;
    background: var(--app-card);
}
.email-send-tabs__headers {
    border-bottom: 1px solid #e8eaf0;
}
.email-send-tabs__headers ::v-deep .v-tabs-bar {
    background: var(--app-tabs) !important;
}
.email-send-tabs__headers ::v-deep .v-tab {
    flex-basis: 0;
    min-width: auto;
    min-height: 46px;
    padding: 0 18px;
    font-size: .92rem;
    font-weight: 600;
    letter-spacing: .01em;
    text-transform: none;
    color: var(--app-tabs-text) !important;
}
.email-send-tabs__headers ::v-deep .v-tab--active {
    background: var(--app-tabs-active-background);
    color: var(--app-tabs-active) !important;
}
.email-send-tabs__headers ::v-deep .v-tabs-slider {
    background-color: var(--app-tabs-active) !important;
    border-color: var(--app-tabs-active) !important;
}
.email-send-tabs__content {
    background: var(--app-tabs-content);
}
@media (max-width: 960px) {
    .email-send-tabs { border-radius: 7px; }
    .email-send-tabs__headers ::v-deep .v-tab {
        min-height: 42px;
        padding: 0 13px;
        font-size: .86rem;
    }
}
.email-attachments-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 230px), 1fr));
    gap: 6px;
}
.email-attachment {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    min-width: 0;
    border: 1px solid rgba(128, 128, 128, 0.24);
    border-radius: 8px;
}
.email-attachment--selected {
    background: rgba(33, 150, 243, 0.06);
    border-color: rgba(33, 150, 243, 0.3);
}
.email-attachment > .v-input {
    flex: 0 0 auto;
}
.email-attachment__content {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    line-height: 18px;
}
.email-attachment__name {
    font-weight: 500;
    overflow-wrap: anywhere;
}
.email-attachment__status {
    margin-left: 5px;
    font-size: 11px;
    white-space: nowrap;
}
</style>
